<template>
    <div>
        <fieldset
            v-for="floor in floors"
            :key="`floor-${floor.key}`"
            :class="{
                'theme--dark': $vuetify.theme.isDark,
                'theme--light': !$vuetify.theme.isDark
            }"
            class="mb-4 px-2 pb-2"
        >
            <legend class="ml-4 px-1 subtitle-1">
                {{ floor.title }}
            </legend>
            <div class="d-flex flex-wrap">
                <room-view
                    v-for="room in floor.rooms"
                    :key="`room-${room.id}`"
                    :building="room.building"
                    :wing="room.wing"
                    :floor="room.floor"
                    :room="room.room"
                    :devices="roomDevices(room)"
                    @device-click="$emit('device-click', $event)"
                ></room-view>
            </div>
        </fieldset>
    </div>
</template>

<script>
import RoomView from './RoomView';

export default {
    name: 'BuildingView',
    components: {
        'room-view': RoomView
    },
    props: {
        floors: {
            type: Array,
            required: true
        }
    },
    methods: {
        roomDevices(room) {
            if (room && room.serviceAccount && room.serviceAccount.devices) {
                return room.serviceAccount.devices;
            }
            return [];
        }
    }
};
</script>

<style lang="scss" scoped>
.theme--dark {
    .room-view {
        border: solid thin rgba(map-get($shades, 'white'), 0.4);
    }
}
.theme--light {
    .room-view {
        border: solid thin rgba(map-get($shades, 'black'), 0.45);
    }
}
</style>
